var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourglassIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "04dffa1c85"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "849e74f375"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#04dffa1c85)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    width: 36,
    fill: "#000000",
    y: -3,
    height: 36.000001,
    fillOpacity: 0.73
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "3a87deb4c1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.585938 0.28125 L 9.296875 0.28125 L 9.296875 14.796875 L 0.585938 14.796875 Z M 0.585938 0.28125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d68c802c5a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 11,
    y: 0,
    height: 15
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "df3ea90ecf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10 26 L 20 26 L 20 29.03125 L 10 29.03125 Z M 10 26 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#849e74f375)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 10, 7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d68c802c5a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3a87deb4c1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.59375 14.003906 L 0.59375 14.117188 C 0.59375 14.492188 0.894531 14.796875 1.261719 14.796875 L 8.621094 14.796875 C 8.988281 14.796875 9.289062 14.492188 9.289062 14.117188 L 9.289062 14.003906 C 9.289062 13.628906 8.988281 13.324219 8.621094 13.324219 L 8.621094 11.257812 C 8.621094 10.554688 8.175781 9.683594 7.628906 9.273438 L 5.5 7.675781 L 5.5 7.402344 L 7.628906 5.816406 C 8.1875 5.398438 8.621094 4.523438 8.621094 3.832031 L 8.621094 1.757812 C 8.988281 1.757812 9.289062 1.449219 9.289062 1.074219 L 9.289062 0.960938 C 9.289062 0.589844 8.988281 0.28125 8.621094 0.28125 L 1.261719 0.28125 C 0.894531 0.28125 0.59375 0.589844 0.59375 0.960938 L 0.59375 1.074219 C 0.59375 1.449219 0.894531 1.757812 1.261719 1.757812 L 1.261719 3.820312 C 1.261719 4.523438 1.695312 5.398438 2.253906 5.804688 L 4.382812 7.390625 L 4.382812 7.664062 L 2.253906 9.253906 C 1.695312 9.671875 1.261719 10.546875 1.261719 11.238281 L 1.261719 13.324219 C 0.894531 13.324219 0.59375 13.628906 0.59375 14.003906 Z M 1.707031 11.257812 C 1.707031 10.703125 2.074219 9.96875 2.523438 9.636719 L 4.742188 7.980469 C 4.796875 7.9375 4.832031 7.867188 4.832031 7.800781 L 4.832031 7.300781 C 4.832031 7.234375 4.796875 7.164062 4.742188 7.121094 L 2.523438 5.453125 C 2.085938 5.125 1.707031 4.386719 1.707031 3.832031 L 1.707031 1.757812 L 8.175781 1.757812 L 8.175781 3.820312 C 8.175781 4.375 7.796875 5.113281 7.363281 5.441406 L 5.144531 7.109375 C 5.085938 7.15625 5.054688 7.222656 5.054688 7.289062 L 5.054688 7.789062 C 5.054688 7.859375 5.085938 7.925781 5.144531 7.972656 L 7.363281 9.625 C 7.796875 9.957031 8.175781 10.703125 8.175781 11.25 L 8.175781 13.324219 L 7.617188 13.324219 L 7.617188 11.542969 C 7.617188 11.023438 7.292969 10.386719 6.894531 10.070312 L 5.085938 8.707031 C 5.007812 8.652344 4.898438 8.652344 4.820312 8.707031 L 3 10.070312 C 2.589844 10.375 2.265625 11.023438 2.265625 11.53125 L 2.265625 13.324219 L 1.707031 13.324219 Z M 1.707031 11.257812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 5.074219 6.359375 L 6.882812 5 C 6.960938 4.941406 6.992188 4.839844 6.960938 4.75 C 6.925781 4.660156 6.847656 4.589844 6.75 4.589844 L 3.113281 4.589844 C 3.011719 4.589844 2.933594 4.660156 2.902344 4.75 C 2.867188 4.839844 2.902344 4.941406 2.980469 5 L 4.796875 6.359375 C 4.839844 6.394531 4.886719 6.40625 4.929688 6.40625 C 4.996094 6.40625 5.042969 6.394531 5.074219 6.359375 Z M 5.074219 6.359375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#df3ea90ecf)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 10.585938 26.128906 L 13.492188 26.128906 L 13.492188 29.03125 L 10.585938 29.03125 M 16.394531 26.128906 L 19.296875 26.128906 L 19.296875 29.03125 L 16.394531 29.03125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassIcon);
export default __webpack_public_path__ + "static/media/hourglass-icon.b7f6d707b306f9af6c9c18ae6ff3c660.svg";
export { ForwardRef as ReactComponent };